import { ICity } from 'app/shared/model/city.model';

export interface ICountry {
  id?: number;
  countryName?: string | null;
  cities?: ICity[] | null;
}

export const defaultValue: Readonly<ICountry> = {};
